module.exports = __webpack_public_path__ + "img/iconmonstr-speech-bubble-26-240.eb7f099.png";